import { paddingSmall, paddingXL } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { SearchModalPaddingHorizontal } from "../constants/SearchModalStyleConstants";

const SearchHeader = ({ text }: { text: string }) => {
	return (
		<Text
			bold
			large
			style={{
				marginBottom: paddingSmall,
				marginTop: paddingXL,
				marginHorizontal: SearchModalPaddingHorizontal,
			}}
		>
			{text}
		</Text>
	);
};
export default SearchHeader;
